export function readAuthUserId(): string | null {
  try {
    const raw = localStorage.getItem('authState');
    if (!raw) return null;
    const token = (JSON.parse(raw) as { accessToken?: string }).accessToken;
    const payloadSegment = token?.split('.')[1];
    if (!payloadSegment) return null;
    const json = atob(payloadSegment.replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json) as { sub?: string; userId?: string; id?: string };
    return payload.sub ?? payload.userId ?? payload.id ?? null;
  } catch {
    return null;
  }
}
